import { render, staticRenderFns } from "./WBtnUpdate.vue?vue&type=template&id=cd7b4b50&scoped=true&"
import script from "./WBtnUpdate.vue?vue&type=script&setup=true&lang=js&"
export * from "./WBtnUpdate.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd7b4b50",
  null
  
)

export default component.exports